// Wishlist, compare, quick view, recently viewed, barcode scan.
import { $, $$, api, cardHTML, esc, gradeLabel, icon, isAr, money, showPrices, SPEC_LABELS, specValue, store, t, toast } from "./util";
import { cart, syncAddButtons } from "./cart";
import { refreshMotion } from "./motion-lite";

const WISH = "darat_wish", CMP = "darat_cmp", RECENT = "darat_recent";
const list = (k) => store(k) || [];
const setList = (k, v) => store(k, v);

// ---------------------------------------------------------------- wishlist
function paintWish() {
	const w = new Set(list(WISH));
	$$("[data-wish]").forEach((b) => { const on = w.has(b.dataset.wish); b.classList.toggle("is-on", on); b.setAttribute("aria-pressed", on); });
	$$("[data-wish-count]").forEach((e) => { e.textContent = w.size; e.hidden = !w.size; });
}
function toggleWish(code) {
	let w = list(WISH);
	const on = !w.includes(code);
	w = on ? [code, ...w].slice(0, 60) : w.filter((c) => c !== code);
	setList(WISH, w); paintWish();
	toast(`${icon("check-circle")}<span>${on ? t("تمت الإضافة إلى المفضلة", "Saved to wishlist") : t("تمت الإزالة من المفضلة", "Removed from wishlist")}</span><a href="/wishlist">${t("المفضلة", "Wishlist")}</a>`);
}

// ---------------------------------------------------------------- compare
function paintCompare() {
	const c = list(CMP);
	$$("[data-cmp]").forEach((b) => b.classList.toggle("is-on", c.includes(b.dataset.cmp)));
	let tray = $("[data-cmp-tray]");
	if (!c.length) { tray?.remove(); return; }
	if (!tray) {
		tray = document.createElement("div");
		tray.className = "ds-cmptray"; tray.setAttribute("data-cmp-tray", "");
		document.body.appendChild(tray);
	}
	tray.innerHTML = `<span>${icon("check-circle")} ${t(`للمقارنة: ${c.length}`, `${c.length} to compare`)}</span>
		<a class="ds-btn ds-btn--primary" href="/compare?c=${encodeURIComponent(c.join(","))}">${t("قارن الآن", "Compare now")}</a>
		<button type="button" class="ds-link" data-cmp-clear>${t("مسح", "Clear")}</button>`;
}
function toggleCompare(code) {
	let c = list(CMP);
	if (c.includes(code)) c = c.filter((x) => x !== code);
	else if (c.length >= 4) { toast(`<span>${t("الحد الأقصى للمقارنة ٤ منتجات", "You can compare up to 4 products")}</span>`); return; }
	else c = [...c, code];
	setList(CMP, c); paintCompare();
}

// ---------------------------------------------------------------- quick view
async function quickView(code) {
	let box = $("[data-qv-sheet]");
	if (!box) {
		box = document.createElement("div");
		box.className = "ds-sheet ds-qv"; box.setAttribute("data-sheet", "qv"); box.setAttribute("data-qv-sheet", "");
		document.body.appendChild(box);
	}
	box.hidden = false; document.documentElement.style.overflow = "hidden";
	box.innerHTML = `<div class="ds-qv__panel" role="dialog" aria-modal="true"><div class="ds-skel" style="min-height:360px"></div></div>`;
	let p;
	try { p = await api("darat.storefront.api.product_brief", { code }); } catch (e) { box.hidden = true; document.documentElement.style.overflow = ""; return; }
	const name = isAr && p.a ? p.a : p.n;
	const specs = Object.entries(p.sp || {}).map(([k, v]) => `<li><span>${esc(SPEC_LABELS[k] || k)}</span><b dir="auto">${esc(specValue(v))}</b></li>`).join("");
	box.querySelector(".ds-qv__panel").innerHTML = `
		<button type="button" class="ds-iconbtn ds-qv__x" data-close aria-label="${t("إغلاق", "Close")}">${icon("x")}</button>
		<div class="ds-qv__media">${p.images && p.images.length ? `<img src="${esc(p.images[0])}" alt="${esc(name)}">` : `<div class="ds-art"><svg viewBox="0 0 160 120"><use href="#part-${esc(p.ic)}"/></svg></div>`}
			${p.images && p.images.length > 1 ? `<div class="ds-qv__thumbs">${p.images.map((s, i) => `<button type="button" data-qv-img="${esc(s)}" class="${i ? "" : "is-on"}"><img src="${esc(s)}" alt=""></button>`).join("")}</div>` : ""}</div>
		<div class="ds-qv__info">
			<div class="ds-card__meta">${p.b ? `<span>${esc(p.b)}</span>` : ""}${p.gr ? `<span class="ds-grade ds-grade--${esc(p.gr)}">${gradeLabel(p.gr)}</span>` : ""}<span dir="ltr">${esc(p.c)}</span></div>
			<h2 class="ds-h3">${esc(name)}</h2>
			${showPrices ? `<p class="ds-qv__price">${money(p.p)} <small>${t("شامل الضريبة", "incl. VAT")}</small></p>` : ""}
			${p.q <= 0 ? `<p class="ds-stock is-out"><i></i>${t("غير متوفر حالياً", "Out of stock — can't be ordered")}</p>` : p.q <= (window.darat_store?.lowStock || 3) ? `<p class="ds-stock is-low"><i></i>${t("كمية محدودة", "Low stock")}</p>` : ""}
			${specs ? `<ul class="ds-qv__specs">${specs}</ul>` : ""}
			${p.m && p.m.length ? `<div class="ds-card__pn" dir="ltr">${p.m.slice(0, 6).map((m) => `<span>${esc(m)}</span>`).join("")}</div>` : ""}
			<div class="ds-qv__actions">
				<button type="button" class="ds-btn ds-btn--primary" data-add="${esc(p.c)}" ${p.q <= 0 ? "disabled" : ""}>${icon("cart-plus")} ${t("أضف إلى السلة", "Add to cart")}</button>
				<a class="ds-btn ds-btn--ghost" href="/p/${esc(p.u)}">${t("التفاصيل الكاملة", "Full details")}</a>
			</div>
		</div>`;
}

// ---------------------------------------------------------------- recently viewed + wishlist/compare pages
async function renderCodes(el, codes) {
	if (!codes.length) { el.hidden = true; return; }
	try {
		const res = await api("darat.storefront.api.products", { codes: codes.join(","), page_len: codes.length });
		const grid = el.querySelector("[data-codes-grid]");
		grid.innerHTML = res.items.map(cardHTML).join("");
		el.hidden = !res.items.length;
		refreshMotion(grid); syncAddButtons(); paintWish(); paintCompare();
	} catch (e) { el.hidden = true; }
}

function recentlyViewed() {
	const pdp = $("[data-buy]");
	if (pdp) {
		const code = pdp.dataset.buy;
		setList(RECENT, [code, ...list(RECENT).filter((c) => c !== code)].slice(0, 12));
	}
	$$("[data-recent]").forEach((el) => {
		const skip = pdp ? pdp.dataset.buy : "";
		const codes = list(RECENT).filter((c) => c !== skip).slice(0, 5);
		if (codes.length >= 2) renderCodes(el, codes); else el.hidden = true;
	});
	const wl = $("[data-wishlist-page]");
	if (wl) { const w = list(WISH); if (w.length) renderCodes(wl, w); $("[data-wish-empty]").hidden = !!w.length; }
}

// ---------------------------------------------------------------- barcode / part-number scan
async function scanBarcode(input) {
	if (!("BarcodeDetector" in window) || !navigator.mediaDevices?.getUserMedia) return;
	const box = document.createElement("div");
	box.className = "ds-scan";
	box.innerHTML = `<div class="ds-scan__panel"><video playsinline muted></video><span class="ds-scan__frame"></span>
		<p>${t("وجّه الكاميرا نحو الباركود أو رقم القطعة", "Point the camera at the barcode or part label")}</p>
		<button type="button" class="ds-btn ds-btn--ghost">${t("إلغاء", "Cancel")}</button></div>`;
	document.body.appendChild(box);
	const video = box.querySelector("video");
	let stream, stop = false;
	const close = () => { stop = true; stream?.getTracks().forEach((tr) => tr.stop()); box.remove(); };
	box.querySelector("button").onclick = close;
	try {
		stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } });
		video.srcObject = stream; await video.play();
		const det = new window.BarcodeDetector();
		const loop = async () => {
			if (stop) return;
			try {
				const codes = await det.detect(video);
				if (codes.length) { input.value = codes[0].rawValue; input.dispatchEvent(new Event("input", { bubbles: true })); close(); return; }
			} catch (e) { /* keep scanning */ }
			requestAnimationFrame(loop);
		};
		loop();
	} catch (e) { close(); toast(`<span>${t("تعذّر فتح الكاميرا", "Camera not available")}</span>`); }
}

export function initFeatures() {
	paintWish(); paintCompare(); recentlyViewed();
	if ("BarcodeDetector" in window) $$("[data-scan]").forEach((b) => (b.hidden = false));
	document.addEventListener("click", (e) => {
		const w = e.target.closest("[data-wish]"); if (w) { e.preventDefault(); toggleWish(w.dataset.wish); return; }
		const c = e.target.closest("[data-cmp]"); if (c) { e.preventDefault(); toggleCompare(c.dataset.cmp); return; }
		if (e.target.closest("[data-cmp-clear]")) { setList(CMP, []); paintCompare(); return; }
		const q = e.target.closest("[data-qv]"); if (q) { e.preventDefault(); quickView(q.dataset.qv); return; }
		const qi = e.target.closest("[data-qv-img]");
		if (qi) { const img = qi.closest(".ds-qv__media").querySelector(":scope > img"); if (img) img.src = qi.dataset.qvImg; $$("[data-qv-img]").forEach((b) => b.classList.toggle("is-on", b === qi)); }
		const sc = e.target.closest("[data-scan]"); if (sc) { e.preventDefault(); scanBarcode($("[data-search-input]")); }
		if (e.target.matches(".ds-qv")) { e.target.hidden = true; document.documentElement.style.overflow = ""; }
	});
	document.addEventListener("darat:content", () => { paintWish(); paintCompare(); });
}
